import { ContentSponsoredRetrievePlacementEnum } from '@/clients/unifiedApi';

export const BUYER_DASHBOARD_AD_PLACEMENTS = getLeaderBoardPlacementEnum('BuyerDashHero');
export const SELLER_DASHBOARD_AD_PLACEMENTS = getLeaderBoardPlacementEnum('SellerDashHero');

/**
 * Returns the list of ad placements for the dashboard carousel.
 * Only includes placements with prefixes BuyerDashHero-* or SellerDashHero-*.
 */
function getLeaderBoardPlacementEnum(
  prefix: 'BuyerDashHero' | 'SellerDashHero',
): ContentSponsoredRetrievePlacementEnum[] {
  return Object.keys(ContentSponsoredRetrievePlacementEnum)
    .filter((key) => key.startsWith(prefix))
    .map((key) => ContentSponsoredRetrievePlacementEnum[key]);
}

/**
 * Used by the data team to filter and analyze user behavior
 */
export const CTA_CLICKED = {
  BRAND: 'brand',
  CART: 'cart',
  PRODUCT: 'product',
  VENDOR: 'vendor',
} as const;

/**
 * Default interval for autoplaying carousels
 */
export const DEFAULT_AUTOPLAY_INTERVAL = 4000;

// TODO: Use generated unified api values https://leaflink.atlassian.net/browse/ADS-1532
export const RECENTLY_PURCHASED_PLACEMENTS = {
  DASHBOARD: 'recommended-brands-recently-purchased-dashboard',
  SHOP_BRANDS: 'recommended-brands-recently-purchased-shop-brands',
} as const;
